export function AppLoadingScreen() {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="gradient-primary h-8 w-8 animate-pulse rounded-lg" />
    </div>
  );
}
